module.exports = __webpack_public_path__ + "static/media/unboxing_spring_6.d203f93e.jpg";